import { insuranceCompaniesResponse } from "../../types/graphQlQuery.interface";
import { LeadModel } from "./LeadModel";
import { Material } from "./Material";
import { Payment, PaymentMethodForProjectDetails } from "./payment";
export interface ProjectProgressType {
  id: number;
  step: number;
  projectId: number;
  title: string;
  description: string;
  remarks?: string;
  approved: boolean;
  completed: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface Customer {
  id: number;
  email: string;
  password?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
  resetCode?: number;
  expiry?: string;
  verified?: boolean;
  createdAt: string;
  updatedAt: string;
  leads: LeadModel;
  address: Address[];
  projectId: number;
  addedBy?: string;
  emailAddedBy?: string;
}

export interface Address {
  id: number;
  userId: number;
  street: string;
  zipCode: string;
  city: string;
  state: string;
  lat?: number;
  lng?: number;
  streetAddress?: string;
}

export interface Docs {
  id: number;
  project_id: number;
  uploaded_by: string;
  file_url: string;
  file_type: string;
  meta_data: string;
  visible: boolean;
  created_at: string;
  updated_at: string;
}
export interface Product {
  id: number;
  name: string;
  paymentMethods: PaymentMethodForProjectDetails[];
  thumbnail: string;
  duration: string;
  priority: number;
  createdAt: string;
  updatedAt: string;
}

export interface ProjectFiles {
  id: number;
  projectId: number;
  url: string;
  type: string;
  createdAt: string;
  updatedAt: string;
}

export interface Project {
  id: number;
  customerId: number;
  projectRefNumber: string;
  customer?: Customer;
  status: string;
  progress?: Progress[];
  products?: Product[];
  files?: ProjectFile[];
  createdAt?: string;
  updatedAt?: string;
  paymentType?: PayType;
  insuranceClaim?: InsuranceProvider[];
  orderStatus?: OrderStatus[];
  MeasurementSupportRequested?: boolean;
}

export interface OrderStatus {
  productSystemId: number; 
  componentType: 'MATERIAL' | 'CONTRACTOR'; 
  orderSent: boolean;
  orderConfirmed: boolean;
}

export interface InsuranceProvider {
  id: number;
  providerId: number;
  companyName: string;
  Insurer: string;
  ClaimNumber: string;
  ClaimDate: string;
  TotalPayout: number;
  Approved: boolean;
}

export interface ProjectDetails {
  project: Project;
  progress: Progress[];
  docs?: Docs[];
  projectMaterials?: Material[];
}

export interface GetProjectsDetailsData {
  projects: Project[];
}

export interface Progress {
  id: number;
  step: number;
  projectId: number;
  title: string;
  description: string;
  remarks?: string;
  approved: boolean;
  completed: boolean;
  payment?: Payment;
  createdAt?: string;
  updatedAt?: string;
}

export interface GetCustomerResponse {
  customers: Customer[];
}

export interface GetCustomerByIDResponse {
  customer: Customer;
}
export enum PayType {
  INSURANCE = "INSURANCE",
  CASH = "CASH",
}
export enum FileType {
  PHOTO = "PHOTO",
  LICENSE = "LICENSE",
  DOCUMENT = "DOCUMENT",
  INSURANCE = "INSURANCE",
  ESTIMATE = "ESTIMATE",
  AFFIDAVIT = "AFFIDAVIT",
  INVOICE_DOC = "INVOICE_DOC",
  MERGED_INVOICE = "MERGED_INVOICE",
  INVOICE = "INVOICE",
  PRODUCTION_PHOTOS = "PRODUCTION_PHOTOS",
  COMPLETION_PHOTOS = "COMPLETION_PHOTOS",
  SUPPLEMENTAL_PHOTOS = "SUPPLEMENTAL_PHOTOS",
  MEASUREMENT = "MEASUREMENT",
  EXTRA_ESTIMATE = "EXTRA_ESTIMATE",
}

export interface ProjectFile {
  id: number;
  projectId: number;
  url: string;
  unsignedUrl?: string;
  type: FileType;
  createdAt: string;
  updatedAt: string;
  fileName?: string;
  archived?: boolean;
  dateOfLoss?: string; // Optional field for date of loss
  dateOfScope?: string; // Optional field for date of scope
  customerVisibility?: boolean;
}

export interface CreateProjectFileInput {
  projectId: number;
  url: string;
  type: FileType;
  fileName?: string;
}

export interface UpdateProjectFileInput {
  id: number;
  projectId: number;
  url?: string;
  type?: FileType;
  fileName?: string;
  archived?: boolean;
  dateOfLoss?: string; // Optional field for date of loss
  dateOfScope?: string; // Optional field for date of scope
}

export enum ProgressStatus {
  ProjectSetup = "ProjectSetup",
  InsuranceClaimFiled = "InsuranceClaimFiled",
  ProjectPlanning = "ProjectPlanning",
  InsuranceScopeUploaded = "InsuranceScopeUploaded",
  AdminMeasurementInput = "AdminMeasurementInput",
  MaterialMeasurementInput = "MaterialMeasurementInput",
  LaborMeasurementInput = "LaborMeasurementInput",
  Ordering = "Ordering",
  MaterialsSelected = "MaterialsSelected",
  ContractorsSelected = "ContractorsSelected",
  EstimateSigned = "EstimateSigned",
  InstallDateSelected = "InstallDateSelected",
  PaymentMade = "PaymentMade",
  Construction = "Construction",
  Completion = "Completion",
  Archived = "Archived",
}

export enum ArchiveReason {
  DoNotContact = "DoNotContact",
  CustomerStoppedCommunicating = "CustomerStoppedCommunicating",
  ProjectCompleted = "ProjectCompleted",
  UnableToCollect = "UnableToCollect",
  CancelledProject = "CancelledProject",
  UnserviceableRequest = "UnserviceableRequest",
  TestProject = "TestProject",
  Other = "Other",
}

export interface ProjectPaymentAdmin {
  projectId: number;
  checkType: CheckType;
  payThrough: PayThrough;
  amount: number;
  title: string;
  description: string;
  remarks?: string;
  transactionId?: string;
  images?: string;
}

export interface UpdateProjectPaymentAdmin {
  Id: number;
  projectId: number;
  checkType?: CheckType;
  payThrough?: PayThrough;
  amount: number;
  title?: string;
  description?: string;
  remarks?: string;
  transactionId?: string;
  images?: string;
}

export enum CheckType {
  first = "FIRST",
  second = "SECOND",
  partial = "PART_PAYMENT",
  final = "FINAL_INVOICE_PAYMENT"
}

export enum PayThrough {
  card = "CARD",
  ach = "ACH",
  cash = "CASH",
  cheque = "CHEQUE",
}